import styled from 'styled-components';
import color from '../../../config/colors.json';

export const Overlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background-color: rgba(0,0,0,.5);
    z-index: 3;
`;

export const Content = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%); 
    background-color: ${color.light};
    border-radius: ${({ borderradius }) => borderradius};
    width: ${({ width }) => width};
`;
